export default __webpack_public_path__ + "static/media/computer-courses-icon.c391c791.png";